import { createSlice } from "@reduxjs/toolkit";
import {
  getComment,
  getReplyComment,
  getLatestComment,
  createComment,
  getUpdatedComment,
  getUpdateRepliedComment,
} from "../3- actions/comments";
// import { reset } from "../3- actions/novels";
export const counterSlice = createSlice({
  name: "comments",
  initialState: {
    userComments: [],
    latestComments: [],
  },
  reducers: {
    CLEAR_COMMENTS(state) {
      state.userComments = [];
      state.userComments.pending = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLatestComment.fulfilled, (state, action) => {
      state.latestComments = {
        ...state.latestComments,
        latestComments: action.payload,
        pending: false,
      };
    });
    builder.addCase(getLatestComment.pending, (state, action) => {
      state.latestComments = {
        ...state.latestComments,
        pending: true,
      };
    });
    builder.addCase(getComment.fulfilled, (state, action) => {
      state.userComments = {
        ...state.userComments,
        comments: action.payload,
        pending: false,
      };
    });
    builder.addCase(getComment.pending, (state, action) => {
      state.userComments = {
        ...state.userComments,
        pending: true,
      };
    });
    builder.addCase(getUpdatedComment.fulfilled, (state, action) => {
      state.userComments = {
        ...state.userComments,
        comments: state.userComments.comments.map((comment) =>
          comment._id === action.payload._id ? action.payload : comment
        ),
      };
    });
    builder.addCase(createComment.fulfilled, (state, action) => {
      state.userComments = {
        ...state.userComments,
        comments: [action.payload, ...state.userComments.comments],
      };
    });
  },
});

export default counterSlice.reducer;
export const { CLEAR_COMMENTS } = counterSlice.actions;
